// calculateEqualPayment.js - Revised
export function calculateEqualPayment(data) {
    const { orderAmount, term, rate } = data;

    // Parse input values
    const principal = parseFloat(orderAmount) || 0;
    const months = parseInt(term) || 0;
    const monthlyRate = parseFloat(rate) / 100 || 0;

    if (principal <= 0 || months <= 0 || monthlyRate < 0) {
        return [];
    }

    let payments = [];
    let remainingPrincipal = principal;

    // Zero interest case - simple division
    if (monthlyRate === 0) {
        const monthlyPayment = principal / months;

        for (let i = 0; i < months; i++) {
            // For the last payment, use the exact remaining principal to avoid rounding issues
            const paymentAmount = i === months - 1 ? remainingPrincipal : monthlyPayment;

            payments.push({
                month: i + 1,
                amount: paymentAmount,
                principal: paymentAmount,
                interest: 0,
                remainingPrincipal: i === months - 1 ? 0 : remainingPrincipal - paymentAmount
            });

            remainingPrincipal -= paymentAmount;
        }
    } else {
        // With interest - use the standard formula
        const monthlyPayment = (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months));

        for (let i = 0; i < months; i++) {
            const interest = remainingPrincipal * monthlyRate;
            let principalPayment = monthlyPayment - interest;

            // For the last payment, adjust to clear the remaining principal exactly
            if (i === months - 1) {
                principalPayment = remainingPrincipal;
            }

            const paymentAmount = interest + principalPayment;

            payments.push({
                month: i + 1,
                amount: i === months - 1 ? paymentAmount : monthlyPayment,
                principal: principalPayment,
                interest: interest,
                remainingPrincipal: i === months - 1 ? 0 : remainingPrincipal - principalPayment
            });

            remainingPrincipal -= principalPayment;
        }
    }

    // Format for display with 2 decimal places
    return payments.map(payment => ({
        ...payment,
        amount: parseFloat(payment.amount.toFixed(2)),
        principal: parseFloat(payment.principal.toFixed(2)),
        interest: parseFloat(payment.interest.toFixed(2)),
        remainingPrincipal: parseFloat(payment.remainingPrincipal.toFixed(2)),
    }));
}